import React from 'react';
import { Table, Grid } from 'antd';
import { useTranslation } from 'react-i18next';

const { useBreakpoint } = Grid;

const AppTable = ({
  columns,
  dataSource,
  loading = false,
  pagination = {},
  onChange,
  rowKey = 'id',
  scroll,
  showTotal = true,
  className,
  size: propSize,
  ...rest
}) => {
  const screens = useBreakpoint();
  const { t } = useTranslation();

  const defaultShowTotal = (total, range) => {
    const pageSizeFromRange = (range && range.length === 2) ? (range[1] - range[0] + 1) : undefined;
    const currentFromRange = (range && range.length === 2 && pageSizeFromRange) ? Math.ceil(range[0] / pageSizeFromRange) : undefined;
    const currentPage = (pagination && pagination.current) || currentFromRange || 1;
    const pageSizeValue = (pagination && pagination.pageSize) || pageSizeFromRange || 10;
    const totalPages = Math.max(1, Math.ceil((total || 0) / pageSizeValue));
    return `${range?.[0] || 0}-${range?.[1] || 0} ${t('of', { defaultValue: 'of' })} ${total} ${t('items', { defaultValue: 'items' })}`;
  };

  const mergedPagination = pagination === false ? false : {
    showSizeChanger: true,
    showQuickJumper: true,
    pageSizeOptions: ['10', '25', '50', '100'],
    showTotal: showTotal ? defaultShowTotal : undefined,
    ...pagination,
  };

  const mergedScroll = {
    x: 'max-content',
    ...scroll,
  };

  const size = propSize ?? 'small';

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      rowKey={rowKey}
      pagination={mergedPagination}
      onChange={onChange}
      scroll={mergedScroll}
      size={size}
      className={className}
      {...rest}
    />
  );
};

export default AppTable;


